import { Component } from "@angular/core";

@Component({
    selector: "mobi-office-lib-footer-section",
    templateUrl: "./footer-section.component.html",
    styleUrls: ["./footer-section.component.scss"],
    standalone: false
})
export class FooterSectionComponent {}
